
import { GripVertical } from "lucide-react";
import {
  useSortable,
} from '@dnd-kit/sortable';
import {
  CSS,
} from '@dnd-kit/utilities';

interface SortableWidgetProps {
  id: string;
  children: React.ReactNode;
  isCustomizing: boolean;
}

export const SortableWidget = ({ id, children, isCustomizing }: SortableWidgetProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className="relative">
      {isCustomizing && (
        <div 
          className="absolute top-2 left-2 z-10 cursor-grab active:cursor-grabbing bg-white/90 rounded p-1 shadow-sm border border-gray-200 hover:border-blue-400 transition-colors"
          {...attributes}
          {...listeners}
        >
          <GripVertical className="w-4 h-4 text-gray-500" />
        </div>
      )}
      <div className={isCustomizing ? 'border-2 border-dashed border-blue-300 rounded-lg p-2' : ''}>
        {children}
      </div>
    </div>
  );
};
